
import EventOverview from "../../components/EventDetailPage/EventOverview.vue";
import Section from "../../components/Section.vue";
import { AxiosClient, AxiosClientServerNuxt } from "~/utils/axios";
import Event from "../../components/InteractiveComponents/Event.vue";
import { mapState } from "vuex";
import { getIdFromSlug } from "../../utils/common";
export default {
  components: { EventOverview, Section, Event },
  layout: "root",
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      eventData: {
        id: 0,
        school_name: "",
        instruction: "",
        school_id: 0,
        sponsors: "",
        title: "",
        // intended_for: "",
        location: "",
        formal: "",
        organizational_units: "",
        num_of_register: 0,
        updated_at: "",
        introduction: "",
        registion_start_time: "",
        created_at: "",
        avatar: "",
        registion_end_time: "",
        deleted_at: null,
        thumb: "",
        other_event: [],
      },
      baseImageURL: this.$config.BASE_URL_STATIC,
    };
  },

  computed: {
    ...mapState("Event", [
      "eventDetail",
      "eventLoading",
      "newestEventLoading",
      "newestEventData",
    ]),
  },

  async mounted() {
    await this.$store.dispatch("Event/getEventDetail", this.$route.params.id);
  },
};
